export default __webpack_public_path__ + "static/roof_b.efef540c1c4148cde52cbe5bb9f873bb.png";